import React, { useState, useCallback } from "react";
import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import SelectBox from "../SelectBox/SelectBox";
import { debounce } from "../../../utils/debounce";
import "./heading.css";
import SearchField from "../SearchField/SearchField";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import RangeFields from "../../../features/Inventory/RangeFields";
import { isSuperAdmin } from "../../../features/customerManagement/utility/authUtils";
const Heading = ({
  heading,
  showSearch,
  dateText,
  arrowRedirection,
  showToFromDate,
  buttonArray,
  handleButtonAction,
  status,
  filters,
  setFilters,
  searchTerm,
  setSearchTerm,
  headingButton,
  headingButtonUrl,
   requestType,
  setRequestType,
  showToggle
}) => {
  // const [filters, setFilters] = useState({
  //   searchTerm: "",
  //   fromDate: null,
  //   toDate: null,
  //   statusId: "",
  //   actionId: "",
  // });

  const navigate = useNavigate();

  const handleNavigation = (prevAction) => {
    if (prevAction) {
      navigate(prevAction);
    } else {
      navigate(-1);
    }
  };

  const handleSearchChange = useCallback(
    debounce((name, value) => {
      setFilters((prev) => ({ ...prev, [name]: value }));
      // onSearch(value);
    }, 2000),
    []
  );

  const handleInputChange = (name, event) => {
    const value = event.target.value;
    setSearchTerm(value);
    handleSearchChange(name, value);
  };

  const handleSelectChange = (field) => (event) => {
    debugger
    const selectedValue = event.target.value;
    setFilters((prev) => ({ ...prev, pageNo: 0, [field]: selectedValue }));
  };
  // console.log(filters, "filter");
  return (
    <Grid
      container
      alignItems="center"
      spacing={2}
      // className="containerCell"
      sx={{
        marginTop: "3rem",
        marginBottom: "1rem",
        borderRadius: "8px",
        paddingRight: "63px",
      }}
    >
      <Grid
        item
        md={arrowRedirection ? 0.6 : 0.4}
        sx={{
          display: "flex",
          alignItems: "center",
          paddingLeft: arrowRedirection && "45px!important",
        }}
      >
        {arrowRedirection && (
          <IconButton
            onClick={() => handleNavigation()}
            sx={{
              border: "1px solid",
              marginRight: "5px",
              height: "36px",
              width: "37px",
              color: "#1976d2",
              borderColor: "#1976d2",
              "&:hover": {
                backgroundColor: "#e3f2fd",
              },
            }}
          >
            <ArrowBack />
          </IconButton>
        )}
      </Grid>
      <Grid
        item
        md={arrowRedirection ? 4.2 : 2.6}
        sx={{ display: "flex", alignItems: "center" }}
      >
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            fontSize: "1.75rem",
            color: "var(--bg)",
            letterSpacing: "0.5px",
            textTransform: "capitalize",
            lineHeight: 1.3,
          }}

          style={{marginTop:"40px"}}
        >
          {heading}
        </Typography>
        {headingButton && (
  <Button
  variant="contained"
  color="primary"
  sx={{
    marginLeft: 2,
    marginTop: "40px",
    bgcolor: "var(--bg)",
    borderRadius: "25px", // Makes the button rounded
    boxShadow: "0 2px 8px rgba(25, 118, 210, 0.15)",
    fontWeight: 600,
    fontSize: "1rem",
    px: 3,
    py: 1,
    transition: "transform 0.2s, box-shadow 0.2s",
    flexShrink: 0,       // ✅ prevents shrinking
    whiteSpace: "nowrap", // ✅ prevents text wrapping/shrinking
    '&:hover': {
      bgcolor: "var(--bg)",
      transform: "scale(1.05)",
    },
  }}
  onClick={() => navigate(`/${headingButtonUrl}`)}
>
  File Upload
</Button>

        )}

      </Grid>
      <Grid
        item
        md={arrowRedirection ? 7 : 9}
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        {showToFromDate && (
          <RangeFields
            filters={filters}
            setFilters={setFilters}
            dateText={dateText}
            searchTerm={searchTerm}
          />
        )}

        {status?.map(
          ({ label, list, hide, key, fetchKey }, index) =>
            hide && (
              <SelectBox
                key={index}
                label={label}
                list={list}
                fetchKey={fetchKey}
                selectedValue={filters?.[key] || ""}
                onChange={handleSelectChange(key)}
              />
            )
        )}
        {showSearch && (
          <SearchField
            setFilters={setFilters}
            setSearchTerm={setSearchTerm}
            searchTerm={searchTerm}
          />
        )}
     {showToggle && (
  <ToggleButtonGroup
    value={requestType}
    exclusive
    size="small"
    onChange={(e, value) => {
      if (value) {
        setRequestType(value);
      }
    }}
    sx={{
      ml: 1,
      backgroundColor: "#f5f5f5",
      borderRadius: "12px",
      p: 0.5,
      boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
      "& .MuiToggleButtonGroup-grouped": {
        border: 0,
        borderRadius: "10px !important",
        px: 3,
        py: 0.8,
        textTransform: "none",
        fontWeight: 600,
        fontSize: "14px",
      },
    }}
  >
    <ToggleButton
      value="INTERNAL"
      sx={{
        "&.Mui-selected": {
          backgroundColor: "#1976d2",
          color: "#fff",
          "&:hover": {
            backgroundColor: "#1565c0",
          },
        },
      }}
    >
      Internal
    </ToggleButton>

    <ToggleButton
      value="EXTERNAL"
      sx={{
        "&.Mui-selected": {
          backgroundColor: "#2e7d32",
          color: "#fff",
          "&:hover": {
            backgroundColor: "#1b5e20",
          },
        },
      }}
    >
      External
    </ToggleButton>
  </ToggleButtonGroup>
)}

       {buttonArray?.length > 0 &&
  buttonArray
    .filter(
      (btn) =>
        (btn.visible ?? true) && // 👈 check per-page visibility
        (!btn.onlyForSuperAdmin || isSuperAdmin()) // 👈 keep your old logic
    )
    .map(({ name, key, icon }) => (
      <Button
        key={key}
        variant="contained"
        size="large"
        className="buttonsStyling"
        onClick={() => handleButtonAction(key)}
        startIcon={icon}
      >
        {name}
      </Button>
    ))}

          
      </Grid>
    </Grid>
  );
};

export default Heading;
